import React, { useContext, useEffect, useState } from "react";

import HotelTabSidebar from "./Components/HotelTabSidebar";
import HRTabSidebar from "./Components/HRTabSidebar";
import TuningSidebar from "./Components/TuningSidebar";

import profile_av from "../../assets/images/profile_av.png";
import profile_man from "../../assets/images/man_avtar.png";
import { AuthContext } from "../../Context/AuthContext";
import { getPropertyDetails } from "../../api/axios";

const CommonSidebar = ({ iconColor }) => {
  const { user, allowedModules } = useContext(AuthContext);
  const [property, setProperty] = useState(null);
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    const loadProperty = async () => {
      if (!user?.property_name) return;
      try {
        const data = await getPropertyDetails(user.property_name);
        setProperty(data);
      } catch (err) {
        // Global interceptor will already show error message.
      }
    };

    loadProperty();
  }, [user?.property_name]);

  const allTabs = [
    {
      id: "tab_hotels",
      label: "F DESK",
      module: "pms",
      component: HotelTabSidebar,
    },
    { id: "tab_hrms", label: "HRMS", module: "hrms", component: HRTabSidebar },
    {
      id: "tab_settings",
      label: "ADMIN",
      module: "admin",
      component: TuningSidebar,
    },
  ];

  const visibleTabs = allTabs.filter((tab) =>
    allowedModules.includes(tab.module)
  );

  // Set the first visible tab as active when visibleTabs change
  useEffect(() => {
    if (visibleTabs.length > 0 && !activeTab) {
      setActiveTab(visibleTabs[0].id);
    }
  }, [visibleTabs, activeTab]);

  //   console.log("Visible Tabs:", visibleTabs);
  //   console.log("Allowed Modules:", allowedModules);
  //     console.log("Active Tab:", activeTab);

  return (
    <aside
      className="ps-xl-5 ps-lg-4 ps-3 pe-2 py-3 sidebar sticky-top"
      id="sidebarDark"
      data-bs-theme='none'
    >
      <nav className="navbar navbar-expand-xl py-0">
        <div
          className="offcanvas offcanvas-start"
          data-bs-scroll="true"
          tabIndex="-1"
          id="offcanvas_Navbar"
        >
          <div className="offcanvas-header">
            <span className="fw-bold fs-5 text-gradient">
              {property ? property.property_name : "Loading..."}
            </span>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body flex-column custom_scroll ps-4 ps-xl-0">
            <div className="d-flex align-items-start mb-4">
              {/* <img
                className="avatar lg rounded-circle border border-3"
                src={profile_man}
                alt="avatar"
              /> */}
              {/* <div className="ms-3 mt-1">
                <h4 className="mb-0 text-gradient title-font">Welcome</h4>
                <span className="text-muted">{user?.role}</span>
              </div> */}

              {/* <div className="d-flex align-items-center p-3 rounded-4 shadow-sm bg-white">
                <div>
                  <h4 className="mb-1 fw-semibold text-dark">Welcome</h4>
                  <span className="badge bg-primary-subtle text-primary rounded-pill px-3 py-2">
                    {user?.role}
                  </span>
                </div>
              </div> */}
              <div className="p-3 rounded-4 bg-white shadow-sm">
                <h3 className="title-font fw-bold text-gradient mb-1">
                  Welcome
                </h3>
                <span className="px-3 py-1 rounded-pill bg-dark text-white small fw-semibold">
                  {user?.name}
                </span>
              </div>
            </div>

            <ul
              className="nav nav-tabs tab-dynamic px-0 mb-4"
              role="tablist"
              style={{ "--dynamic-color": "var(--accent-color)" }}
            >
              {visibleTabs.map((tab, index) => (
                <li className="nav-item" role="presentation" key={tab.id}>
                  <a
                    className={`ps-2 pe-3 nav-link ${
                      index === 0 ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                    href={`#${tab.id}`}
                    role="tab"
                    aria-selected={index === 0}
                    tabIndex={index === 0 ? "0" : "-1"}
                  >
                    {tab.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="tab-content">
              {visibleTabs.map((tab, index) => {
                const TabComponent = tab.component;
                return (
                  <TabComponent
                    isActive={activeTab === tab.id}
                    iconColor={iconColor}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </nav>
    </aside>
  );
};

export default CommonSidebar;
